import { useCalculator } from 'contexts/Calculator/Calculator';
import { NumericFormat } from 'react-number-format';

export default function PdfTable() {
  const calculator = useCalculator();

  return (
    <div className="pdf-show">
      <table className="variant-table">
        <thead>
          <tr>
            <th />
            {calculator.variants.map((variant, index) => (
              <th className={calculator.results[index]?.evaluation || ''} key={index}>
                <div>{calculator.results[index]?.evaluation || " "}</div>
                {variant.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>Sample Size</th>
            {calculator.variants.map((variant, index) => (
              <td className={calculator.results[index]?.evaluation || ''} key={index}>
                {variant.sampleSize && <NumericFormat displayType="text" thousandSeparator value={variant.sampleSize} />}
              </td>
            ))}
          </tr>
          <tr>
            <th>Results</th>
            {calculator.variants.map((variant, index) => (
              <td className={calculator.results[index]?.evaluation || ''} key={index}>
                {variant.result && (
                  <NumericFormat
                    decimalScale={variant.resultType === "percentage" ? 2 : 0}
                    displayType="text"
                    thousandSeparator
                    suffix={variant.resultType === "percentage" ? "%" : ''}
                    value={variant.result}
                  />
                )}
              </td>
            ))}
          </tr>
          <tr>
            <th>Margin of Error</th>
            {calculator.variants.map((variant, index) => (
              <td className={calculator.results[index]?.evaluation || ''} key={index}>
                {calculator.results[index]?.marginOfErrorPercentage && (
                  <NumericFormat decimalScale={2} displayType="text" thousandSeparator suffix="%" value={calculator.results[index]?.marginOfErrorPercentage} />
                )}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
